import { getISOWeek, getISOWeekYear, getQuarter, getYear } from 'date-fns';
import { fmt, zoned } from '@/utils/dates';
import { capitalizeFirstLetter } from '@/utils/strings';

const toPeriodLabel = (granularity: string, period: string) => {
  const z = zoned(period);
  const quarter = getQuarter(z);
  const week = getISOWeek(z);
  const isoYear = getISOWeekYear(z);
  const month = capitalizeFirstLetter(fmt(period, 'MMMM'));
  const year = getYear(z);

  if (granularity === 'week') {
    return `Vecka: ${week} ${isoYear}`;
  }

  if (granularity === 'quarter') {
    return `Q${quarter} ${year}`;
  }

  if (granularity === 'year') {
    return `${year}`;
  }

  return `${month} ${year}`;
};

const cache = new Map<string, string>();

export const getPeriodLabel = (granularity: string, period: string) => {
  const key = `${granularity}|${period}`;
  let label = cache.get(key);
  if (label === undefined) {
    label = toPeriodLabel(granularity, period);
    cache.set(key, label);
  }
  return label;
};
